// action types
export const ENABLE_AUTO_PAYMENT_SUMMARY =
  'rp/autoPaymentSummary/ENABLE_AUTO_PAYMENT_SUMMARY'
export const DISABLE_AUTO_PAYMENT_SUMMARY =
  'rp/autoPaymentSummary/DISABLE_AUTO_PAYMENT_SUMMARY'

// action creators
export const enableAutoPaymentSummary = payload => ({
  type: ENABLE_AUTO_PAYMENT_SUMMARY,
  payload,
})
export const disableAutoPaymentSummary = payload => ({
  type: DISABLE_AUTO_PAYMENT_SUMMARY,
  payload,
})

// reducer
export default (state = false, { type }) => {
  switch (type) {
    case ENABLE_AUTO_PAYMENT_SUMMARY:
      return true
    case DISABLE_AUTO_PAYMENT_SUMMARY:
      return false
    default:
      return state
  }
}
